import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { cn } from "@/lib/utils";

/** Phones show each row as a card of full-width lines; from md up it is a normal table. */
export const CARD_TABLE = "block md:table";
export const CARD_HEADER = "hidden md:table-header-group";
export const CARD_BODY = "block md:table-row-group";
export const CARD_ROW = "flex flex-wrap items-center gap-y-2 py-3 md:table-row md:py-0";
export const CARD_CELL = "block w-full py-0 md:table-cell md:w-auto md:py-3";
/** On a phone card, a cell that shares its line with a trailing control and takes the rest. */
export const CARD_LINE_START = "max-md:w-auto max-md:min-w-0 max-md:flex-1";
/** On a phone card, a control at the right end of a line. */
export const CARD_LINE_END = "max-md:w-auto max-md:shrink-0";

export const TableSkeleton: React.FC<{ columns: number; rows?: number }> = ({
  columns,
  rows = 5,
}) => (
  <Table>
    <TableBody>
      {[...Array(rows)].map((_, row) => (
        <TableRow key={row}>
          {[...Array(columns)].map((_, cell) => (
            <TableCell key={cell}>
              <Skeleton className="h-5 w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

/** One full-width row for an empty list or a load error. */
export const TableMessageRow: React.FC<{
  columns: number;
  error?: boolean;
  children: React.ReactNode;
}> = ({ columns, error = false, children }) => (
  <TableRow className="block md:table-row">
    <TableCell
      colSpan={columns}
      className={cn(
        "block py-10 text-center md:table-cell",
        error ? "text-destructive" : "text-muted-foreground"
      )}
    >
      {children}
    </TableCell>
  </TableRow>
);
